import { createSlice } from "@reduxjs/toolkit";

const signSlice = createSlice({
  name: "sign",
  initialState: {
    value: "number"
  },
  reducers: {
    mailLogin: (state) => {
      state.value = "mail";
    },
    phoneLogin: (state) => {
      state.value = "number";
    },
  },
});

export const { mailLogin, phoneLogin } = signSlice.actions;
export default signSlice.reducer;
